import { render } from "./Fork.vue?vue&type=template&id=2e9cd739"
import script from "./Fork.vue?vue&type=script&lang=js"
export * from "./Fork.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__